import * as React from "react";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormHelperText from "@material-ui/core/FormHelperText";
import Radio from "@material-ui/core/Radio";
import IconButton from "@material-ui/core/IconButton";
import { DateTimePicker, DatePicker, KeyboardDatePicker, KeyboardTimePicker, KeyboardDateTimePicker } from "@material-ui/pickers";
import Select from '@material-ui/core/Select';

import RightArrowIcon from '@material-ui/icons/ArrowForward';
import LeftArrowIcon from '@material-ui/icons/ArrowBack';
import DateIcon from '@material-ui/icons/DateRange'
import TimeIcon from '@material-ui/icons/AvTimer'
import { localizations } from "../../localization/localization";
import * as moment from 'moment';
import SearchIcon from '@material-ui/icons/Search'
import NumberFormat from 'react-number-format'
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import Slider from "@material-ui/core/Slider";

export function renderCheckbox({ label, ...props }: any) {
    return <Checkbox label={label} {...props} />
}

export function renderNewTextField({ label, errors, fullWidth, ...props }: any) {
    return <TextField label={label} placeholder={label} fullWidth={true} InputLabelProps={{ shrink: true }} {...props} />
}

export function renderTextFieldWithSubmitButton({ label, errors, fullWidth, onSubmit, width, ...props }: any) {

    if (!!!width) {
        width = "140px"
    }

    return <TextField
        label={label}
        placeholder={props.placeholder}
        fullWidth={true}
        onKeyPress={(ev: any) => {
            if (ev.key === "Enter" && onSubmit) {
                // Enter to submit
                onSubmit();
                ev.preventDefault();
            }
        }}
        InputLabelProps={{ shrink: true }}
        InputProps={{
            style: { width },
            endAdornment: <InputAdornment position="end">
                <IconButton onClick={() => onSubmit()}>
                    <SearchIcon />
                </IconButton>
            </InputAdornment>
        }}
        {...props} />
}

const IntegerNumberFormatCustom = (props: any) => {
    const { inputRef, ...other } = props;
    const onChange: any = props.onChange;

    return (
        <NumberFormat
            value={props.value}
            decimalScale={0}
            fixedDecimalScale={true}
            decimalSeparator=","
            getInputRef={inputRef}
            isNumericString={true}
            onValueChange={values => {
                onChange(
                    values.value,
                );
            }}
            {...other}
        />
    );
}

export function renderIntegerNumberField({ label, ...props }: any) {
    return <TextField
        type="number"
        label={label}
        fullWidth
        placeholder={label}
        InputLabelProps={{
            shrink: true
        }}
        InputProps={{
            inputComponent: IntegerNumberFormatCustom
        }}
        {...props}
    />
}

const NumberFormatCustom = (props: any) => {
    const { inputRef, ...other } = props;
    const onChange: any = props.onChange;

    return (
        <NumberFormat
            value={props.value}
            decimalScale={2}
            fixedDecimalScale={true}
            decimalSeparator=","
            getInputRef={inputRef}
            isNumericString={true}
            onValueChange={values => {
                onChange(
                    values.floatValue,
                );
            }}
            {...other}
        />
    );
}

export function renderNumberField({ label, ...props }: any) {
    return <TextField
        type="number"
        label={label}
        fullWidth
        placeholder={label}
        InputLabelProps={{
            shrink: true
        }}
        InputProps={{
            inputComponent: NumberFormatCustom
        }}
        {...props}
    />
}

export function renderNewNumberTextField({ label, errors, fullWidth, ...props }: any) {
    return <TextField
        {...props}
        label={label}
        InputProps={{
            inputComponent: NumberFormatCustom
        }}
        fullWidth={true} InputLabelProps={{ shrink: true }} />
}

export function renderNewTextFieldUpperCase({ label, errors, fullWidth, value, ...props }: any) {
    return <TextField label={label} placeholder={label} value={value && value.toUpperCase()} fullWidth={true} InputLabelProps={{ shrink: true }} {...props} />
}

export function renderNoFullWidthTextField({ label, errors, width, ...props }: any) {
    if (!!!width) {
        width = "40px";
    }

    return <TextField label={label} placeholder={label} fullWidth={false} InputLabelProps={{ shrink: true, style: { textAlign: "center" } }} {...props} InputProps={{ style: { width } }} />
}

export function renderNumericNoFullWidthTextField({ label, errors, width, ...props }: any) {
    if (!!!width) {
        width = "40px";
    }

    return <TextField label={label} type="number" placeholder={label} fullWidth={false} inputProps={{ style: { textAlign: "center" } }} InputLabelProps={{ shrink: true, style: { textAlign: "center" } }} {...props} InputProps={{ style: { width, textAlign: "center" } }} />
}

export function renderRadioButton({ label, ...props }: any) {
    return <Radio label={label} {...props} />
}

export function renderMultilineTextField({ label, errors, ...props }: any) {
    return <TextField multiline label={label} placeholder={label} fullWidth InputLabelProps={{ shrink: true }} {...props} />
}

export function renderDateTimeEdit({ label, ...props }: any) {

    const minDate = moment().subtract(7, "days");

    return <KeyboardDateTimePicker
        clearLabel={localizations.actions.clear}
        fullWidth
        label={label}
        keyboard
        ampm={false}
        okLabel={localizations.actions.ok}
        cancelLabel={localizations.actions.cancel}
        keyboardicon={<DateIcon />}
        rightArrowIcon={<RightArrowIcon />}
        leftArrowIcon={<LeftArrowIcon />}
        dateRangeIcon={<DateIcon />}
        timeIcon={<TimeIcon />}
        format="DD.MM.YYYY HH:mm"
        mask="__.__.____ __:__"
        value={props.value}
        required={props.required}
        minDate={minDate}
        showTodayButton
        todayLabel={localizations.common.todayLabel}
        {...props}
    />
}


export function renderDateEdit({ label, ...props }: any) {
    const minDate = moment().subtract(7, "days");

    return <DatePicker
        clearLabel={localizations.actions.clear}
        label={label}
        keyboard
        okLabel={localizations.actions.ok}
        cancelLabel={localizations.actions.cancel}
        keyboardicon={<DateIcon />}
        rightArrowIcon={<RightArrowIcon />}
        leftArrowIcon={<LeftArrowIcon />}
        format="DD.MM.YYYY"
        value={props.value}
        required={props.required}
        minDate={minDate}
        style={{ width: 140 }}
        showTodayButton
        todayLabel={localizations.common.todayLabel}
        {...props}
    />
}

export function renderDatePicker({ label, ...props }: any) {
    const minDate = moment().subtract(7, "days");
    return <KeyboardDatePicker
        clearLabel={localizations.actions.clear}
        okLabel={localizations.actions.ok}
        cancelLabel={localizations.actions.cancel}
        keyboardIcon={<DateIcon />}
        rightArrowIcon={<RightArrowIcon />}
        leftArrowIcon={<LeftArrowIcon />}
        required={props.required}
        minDate={minDate}
        autoOk
        variant="dialog"
        label={label}
        format="DD.MM.YYYY"
        defaultValue={moment().toDate()}
        value={props.value}
        onChange={() => { }}
        fullWidth
        showTodayButton
        todayLabel={localizations.common.todayLabel}
        {...props}
    />
}

export function renderTimePicker({ label, ...props }: any) {
    return <KeyboardTimePicker
        clearLabel={localizations.actions.clear}
        okLabel={localizations.actions.ok}
        cancelLabel={localizations.actions.cancel}
        keyboardIcon={<TimeIcon />}
        required={props.required}
        ampm={false}
        label={label}
        defaultValue={moment().toNow()}
        value={props.value}
        onChange={() => { }}
        fullWidth
        {...props}
    />

}

function parseDate(date: MaterialUiPickersDate, value?: string) {
    let realDate;
    if (value) {
        if (value === 't') {
            realDate = moment();
        }
        else if (value === 'hu') {
            realDate = moment().add(1, "day");
        }
        else if (value === 'y') {
            realDate = moment().add(2, "days");
        }
    }
}

export function renderErrorInfoText(props: any) {
    return <FormHelperText error>{props.children}</FormHelperText>;
}

export function renderSelect({ label, options, ...props }: any) {
    return <Select
        label={label}
        {...props}
    >
        {props.children}
    </Select>
}

export function renderSelectWithTextLabel({ label, ...props }: any) {
    return <TextField
        select
        label={label}
        value={props.value}
        InputLabelProps={{ shrink: true }}
        {...props}
    >
        {props.children}
    </TextField>
}

export const renderNumberSlider = ({ label, ...props }: any) => {
    const handleChange = (ev: any, value: any) => {
        props.onChange(value)
    }

    return (
        <Slider
            min={0}
            max={200}
            valueLabelDisplay="on"
            step={5}
            value={props.value}
            onChange={handleChange}
        />
    );
}



// WEBPACK FOOTER //
// ./src/common/forms/FieldCreators.tsx